import React, { Fragment, useEffect, useMemo, useState } from "react";
import ButtonSearch from "../../components/ButtonSearch";
import {
    Row,
    Col,
    Form,
    Upload,
    DatePicker,
    Input,
    Image,
    Typography,
} from "antd";
import { DonwloadTemplateWatchlist, UploadWatchlist } from "./xls_modal";
import Add from "../../../../components/ModalFormSearch";
import moment from "moment";
import { PostAPI } from "../../../../../../redux";
import {
    SaveOutlined,
    UserAddOutlined,
    UploadOutlined,
} from "@ant-design/icons";
import OfflineAutocomplete from "../../../../../../components/autocomplete/Offline";
import { useDispatch } from "react-redux";
import Country from "country-data";
import { useLanguage } from "../../../../../../hooks/useLanguage";
import MainSelect from "../../../../../../components/autocomplete/MainSelect";
import ENV from "../../../../../../config/env";
import FlagsV2 from "../../../../../../components/FlagsV2";

const { ImageUrl } = ENV;
const { Dragger } = Upload;
const imgUri = ImageUrl || "/images/";

const defValue = {
    name: "",
    notes: "",
    pictures: [],
    old_picts: [],
    dob: null,
    gender: "male",
    nationality: "IDN",
    passport_number: "",
};

const optionGender = [
    {
        label: "Laki-laki",
        value: "male",
    },
    {
        label: "Wanita",
        value: "female",
    },
];

export default function SearchV2({
    onSearchCallback,
    onFormRefresh,
    editData,
    setEditData,
}) {
    const [, getLan] = useLanguage();
    const dispatch = useDispatch();
    const [search, setSearch] = useState({});
    const [model, setModel] = useState(defValue);
    const handleFinish = (rows) => {
        let newModel = { ...model, ...rows };
        const { pictures, nationality, dob, gender, ...rest } = newModel;
        const f = new FormData();
        f.append(
            "body",
            JSON.stringify({
                ...rest,
                gender: gender?.value || gender,
                nationality: nationality.alpha3,
                dob: dob.format("DD-MMM-YYYY"),
            })
        );
        for (let iii = 0; iii < pictures.length; iii++) {
            const { originFileObj } = pictures[iii];
            f.append("picts", originFileObj);
        }
        dispatch(
            PostAPI({ url: "api/v1/watchlist", data: f }).then(() =>
                setModel(defValue)
            )
        );
    };

    const formatedModel = useMemo(() => {
        let newModel = { ...model };
        const defGender = optionGender.find(
            (item) => item.value === model.gender
        );
        const defNationality = Country.countries.all.find(
            (item) => item.alpha3 === model.nationality
        );

        newModel = {
            ...newModel,
            nationality: defNationality,
            gender: defGender,
        };
        const { dob, ...rest } = editData;
        return editData
            ? {
                  ...rest,
                  dob: moment(dob, "DD-MMM-YYYY"),
                  nationality: defNationality,
                  gender: defGender,
              }
            : newModel;
    }, [model, editData]);
    return (
        <Fragment>
            <Row gutter={[16, 16]} style={{ justifyContent: "right" }}>
                <Col lg={5}>
                    <Input
                        size="large"
                        placeholder="Nama"
                        allowClear
                        autoFocus
                        className="input-primary"
                        onChange={(e) =>
                            setSearch({ ...search, name: e.target.value })
                        }
                    />
                </Col>
                <Col lg={3}>
                    <UploadWatchlist
                        style={{ width: "100%" }}
                        onFormSubmit={(rows) => {
                            const data = rows.map(({ dob, ...rest }) => ({
                                ...rest,
                                dob: moment(dob).format("DD-MMM-YYYY"),
                            }));
                            dispatch(
                                PostAPI({
                                    data,
                                    url: "api/v1/watchlist/batch",
                                })
                            ).then((r) => {
                                if (!!r.payload) {
                                    onFormRefresh();
                                }
                            });
                        }}
                    />
                </Col>
                <Col lg={3}>
                    <Add
                        style={{ width: "100%" }}
                        popupClassName="date-picker-popup-new"
                        modalTitle={`${editData ? "Edit" : "Tambah"} Pantauan`}
                        onFinish={(rows) => {
                            handleFinish(rows);

                            // return f;
                        }}
                        onOpenPopup={(open, setOpen) => {
                            if (editData) {
                                setOpen(true);
                            }
                        }}
                        onClosePopup={() => {
                            setEditData(false);
                        }}
                        btnIcon={<SaveOutlined />}
                        btnTitle={"Simpan"}
                        title={"Add"}
                        icon={<UserAddOutlined />}
                        type={"default"}
                        className="btn-default-new"
                        initialValues={formatedModel}
                        withTagFilter={false}
                        FormComponents={() => (
                            <Fragment>
                                {/* <Form.Item name="pictures"> */}
                                {!!model.old_picts &&
                                    Array.isArray(model.old_picts) && (
                                        <div
                                            style={{
                                                marginTop: "15px",
                                                marginBottom: "15px",
                                                display: "flex",
                                                gap: 8,
                                            }}
                                        >
                                            {!!model.old_picts &&
                                                Array.isArray(
                                                    model.old_picts
                                                ) &&
                                                model.old_picts.map(
                                                    (pict, idx) => {
                                                        return (
                                                            <div
                                                                key={`${pict}___${idx}`}
                                                            >
                                                                <Image
                                                                    src={
                                                                        imgUri +
                                                                        pict
                                                                    }
                                                                    width={128}
                                                                    height={128}
                                                                    fallback={`data:image/png;base64,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`}
                                                                />
                                                            </div>
                                                        );
                                                    }
                                                )}
                                        </div>
                                    )}
                                <Dragger
                                    style={{
                                        width: "100%",
                                        marginBottom: 8,
                                    }}
                                    multiple
                                    accept="image/*"
                                    listType="picture-card"
                                    onChange={({ fileList, event }) => {
                                        let result = [];
                                        for (
                                            let iii = 0;
                                            iii < fileList.length;
                                            iii++
                                        ) {
                                            const { status, ...rest } =
                                                fileList[iii];
                                            result.push({
                                                ...rest,
                                                status: "done",
                                            });
                                        }
                                        setModel({
                                            ...model,
                                            pictures: [...result],
                                        });
                                    }}
                                    fileList={model.pictures}
                                    onRemove={(file) => {
                                        const newPicts = model.pictures.filter(
                                            (pict) => file.uid !== pict.uid
                                        );
                                        setModel({
                                            ...model,
                                            pictures: newPicts,
                                        });
                                        return true;
                                    }}
                                >
                                    <div
                                        style={{
                                            display: "flex",
                                            justifyContent: "center",
                                            alignItems: "center",
                                            flexDirection: "column",
                                        }}
                                    >
                                        <div
                                            style={{
                                                padding: "8px",
                                                background: "#f1f1f2",
                                                borderRadius: "6px",
                                                width: "15%",
                                            }}
                                        >
                                            <UploadOutlined />
                                        </div>
                                        <div
                                            style={{
                                                marginTop: 8,
                                            }}
                                        >
                                            <Typography>
                                                Upload Daftar Gambar
                                            </Typography>
                                        </div>
                                    </div>
                                </Dragger>
                                {/* </Form.Item> */}
                                <Form.Item label="Nama" name="name" required>
                                    <Input
                                        autoFocus
                                        placeholder="Ketik Nama..."
                                        required
                                        className="input-primary"
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Nomor Paspor"
                                    name="passport_number"
                                    required
                                >
                                    <Input
                                        placeholder="Ketik Nomor Paspor..."
                                        className="input-primary"
                                    />
                                </Form.Item>

                                <Form.Item
                                    label="Kewarganegaraan"
                                    name="nationality"
                                    required
                                >
                                    <MainSelect
                                        placeholder="Ketik Kewarganegaraan..."
                                        options={Country.countries.all}
                                        filterOption={(input, opt) =>
                                            (opt?.name ?? "")
                                                .toLowerCase()
                                                .includes(input.toLowerCase())
                                        }
                                        getLabel={(val) => {
                                            const {
                                                name,
                                                alpha2,
                                                alpha3,
                                                ...rest
                                            } = val;
                                            return (
                                                <div
                                                    style={{
                                                        display: "flex",
                                                        gap: 8,
                                                        alignItems: "center",
                                                    }}
                                                >
                                                    <FlagsV2
                                                        country_code={alpha2}
                                                    />
                                                    {name}
                                                </div>
                                            );
                                        }}
                                        getValue={(val) =>
                                            val?.alpha3 || val?.alpha2
                                        }
                                    />
                                </Form.Item>
                                <Form.Item label="J/K" name="gender" required>
                                    <MainSelect
                                        options={optionGender}
                                        placeholder="Pilih Jenis Kelamin..."
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Tanggal Lahir"
                                    name="dob"
                                    required
                                >
                                    <DatePicker
                                        placeholder="Pilih Tanggal Lahir..."
                                        className="date-picker-new"
                                        popupClassName="date-picker-popup-new"
                                        style={{ width: "100%" }}
                                        format={"DD-MMM-YYYY"}
                                    />
                                </Form.Item>
                                <Form.Item
                                    label="Catatan"
                                    name="notes"
                                    required
                                >
                                    <Input.TextArea
                                        rows={6}
                                        className="input-primary"
                                        placeholder="Ketik Catatan..."
                                    />
                                </Form.Item>
                            </Fragment>
                        )}
                    />
                </Col>
                <Col lg={5}>
                    <ButtonSearch
                        title="Cari Pantauan"
                        onClick={() => onSearchCallback(search)}
                    />
                </Col>
            </Row>
            <Row
                gutter={[16, 16]}
                style={{ justifyContent: "right", marginTop: 16 }}
            >
                <Col lg={5}>
                    <DonwloadTemplateWatchlist />
                </Col>
            </Row>
        </Fragment>
    );
}
